// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"l2-z"};